import gql from 'graphql-tag';

export const SECRETARY_OF_STATE_REPORT_FRAGMENT = gql`
  fragment SecretaryOfStateReportViewModel on SecretaryOfStateReportViewModel {
    id
    data {
      fields {
        label
        value
      }
    }
    createdDateTime
    createdBy {
      id
      fullName
    }
  }
`;

export const SECRETARY_OF_STATE_LAST_REPORT_FRAGMENT = gql`
  fragment SecretaryOfStateLastReportViewModel on SecretaryOfStateLastReportViewModel {
    id
    data {
      fields {
        label
        value
      }
    }
    nextAvailableAt
    createdDateTime
    canGenerateReport
    createdBy {
      id
      fullName
    }
  }
`;
